
// src/web/components/saved-diary.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/saved-diary'
import Chip from 'react-toolbox/lib/chip'
import Avatar from 'react-toolbox/lib/avatar'
import Link from 'react-toolbox/lib/link'
import ConfirmDialog from './confirm-dialog.jsx'
import moment from 'moment'
import flashTheme from './themes/flash.css'
import savedDiaryTheme from './themes/saved-diary.css'

class SavedDiary extends React.Component {
  state = { deleteConfirm: false, update: undefined }

  constructor() {
    super()
    this.setTimer = (timestamp)=> {
      var interval
      var elapsed = moment().diff(moment(timestamp), 'seconds')
      if (elapsed < 60) // 1分未満
        interval = 30 // 30秒ごと
      else if (elapsed < 10 * 60) // 10分未満
        interval = 2 * 60 // 2分ごと
      else if (elapsed < 60 * 60) // 1時間未満
        interval = 10 * 60 // 10分ごと
      else if (elapsed < 24 * 60 * 60) // 24時間未満
        interval = 60 * 60 // 1時間ごと
      else // それ以降
        interval = 12 * 60 * 60 // 12時間ごと
      this.timer && clearInterval(this.timer)
      this.timer = setInterval(this.update, interval * 1000)
    }
    this.update = ()=> {
      this.setState({ update: new Date() })
    }
  }

  componentDidMount() {
    if (this.props.isCurrent)
      this.setTimer(this.props.diary.updated_at)
  }

  componentWillUnmount() {
    this.timer && clearInterval(this.timer)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isCurrent) {
      this.setTimer(nextProps.diary.updated_at)

      const dom = ReactDOM.findDOMNode(this)
      dom.className = dom.className.replace(flashTheme.flash, '')
      if (this.props.diary.updated_at != nextProps.diary.updated_at) {
        setTimeout(()=> dom.className += ' ' + flashTheme.flash, 50)
      }
    }
  }  

  render() {
    const {
      t,
      diary,
      isCurrent,
      isEdit,
      isFetching,
      deleteSavedDiary,
      editSavedDiary,
    } = this.props

    if (isCurrent)
      return (
        <Chip deletable theme={savedDiaryTheme}
            onDeleteClick={()=> this.setState({ deleteConfirm: true })} >
          <Avatar style={{ background: 'pink' }} icon="mode_edit" />
          {t('format:savedAt', { timestamp: diary.updated_at })}

          <ConfirmDialog open={this.state.deleteConfirm}
            title={t('label:保存された投稿を削除してもいいですか')}
            description={t('label:この操作は取り消せません')}
            yesLabel={t('label:削除')}
            noLabel={t('label:取り消し')}
            onYes={()=> { this.setState({ deleteConfirm: false }); deleteSavedDiary() }}
            onNo={()=> this.setState({ deleteConfirm: false })} />
        </Chip>
      )
    else
      return (
        <Link onClick={!isEdit && !isFetching && editSavedDiary || undefined} theme={savedDiaryTheme} style={{cursor: !isEdit && 'pointer' || 'default'}}>
          <Chip deletable theme={savedDiaryTheme}
            onDeleteClick={(e)=> { e.stopPropagation(); this.setState({ deleteConfirm: true })}} >
            <Avatar icon="save" />
            {diary.subject && (diary.subject.length > 8 && (diary.subject.slice(0, 8) + '...') || diary.subject) ||
            t('format:diary_subject', { reported_at: diary.reported_at, category: t('diary:' + diary.category) })}

            <ConfirmDialog open={this.state.deleteConfirm}
                title={t('label:保存された投稿を削除してもいいですか')}
                description={t('label:この操作は取り消せません')}
                yesLabel={t('label:削除')}
                noLabel={t('label:取り消し')}
                onYes={()=> { this.setState({ deleteConfirm: false }); deleteSavedDiary() }}
                onNo={()=> this.setState({ deleteConfirm: false })} />
          </Chip>
        </Link>
    )  
  }
}

// TODO:
//  自動保存がかかったら保存した時刻を表示してブリンクさせる
//  クリックしたら編集できるように

export const RawSavedDiary = SavedDiary
export default connect(SavedDiary)



// WEBPACK FOOTER //
// ./src/web/components/saved-diary.jsx